import React from "react";

import {
    Box,
    Card,
    CardMedia,
    CardContent,
    CardHeader,
    Typography,
} from "@mui/material";

import Location from "../Location/Location";
import Attendance from "./Attendance";
import RenderDate from "../../../Common/Date/RenderDate";

const EventCard = ({ event, image, avatar }) => {
    return (
        <Card className="card">
            {image && (
                <CardMedia
                    component="img"
                    height="250"
                    image={image}
                    alt={event.name}
                />
            )}

            <CardHeader
                disableTypography
                avatar={avatar}
                title={
                    <Typography component="h2" className="card-header-title">
                        {event.name}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        <RenderDate date={event.dateStart} />
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <Typography variant="body2">
                        {event?.description || ""}
                    </Typography>
                </Box>
            </CardContent>
            {event?.location && (
                <CardContent>
                    <Box className="card-content">
                        <Location
                            name={event?.location?.name}
                            address={event?.location?.address}
                        />
                    </Box>
                </CardContent>
            )}
            {event?.attendance && (
                <CardContent>
                    <Box className="card-content">
                        <Attendance attendance={event?.attendance} />
                    </Box>
                </CardContent>
            )}
        </Card>
    );
};

export default EventCard;
